import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t-2 border-ink bg-ink text-sand"
    >
      <div className="noise-overlay relative">
        <div className="relative z-10 mx-auto max-w-7xl px-6 py-16">
          <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
            {/* Brand */}
            <div>
              <h3 className="font-anton text-3xl tracking-wider stencil-text">
                SEAS THE BAY
              </h3>
              <p className="mt-4 font-courier text-sm leading-relaxed text-sand/70">
                A boutique bed & breakfast on the shores of Daytona Beach.
                Where code meets the coastline.
              </p>
              <p className="mt-2 font-marker text-teal text-sm">
                seasthebay.org
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-anton text-lg tracking-wider uppercase">
                EXPLORE
              </h4>
              <Separator className="my-3 bg-sand/20" />
              <div className="flex flex-col gap-2">
                {[
                  { name: "Rooms & Rates", path: "/rooms" },
                  { name: "Gallery", path: "/gallery" },
                  { name: "About Us", path: "/about" },
                  { name: "Attractions", path: "/attractions" },
                  { name: "Contact", path: "/contact" },
                ].map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="font-outfit text-sm text-sand/70 transition-colors hover:text-teal"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-anton text-lg tracking-wider uppercase">
                FIND US
              </h4>
              <Separator className="my-3 bg-sand/20" />
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-2">
                  <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-coral" />
                  <span className="font-courier text-sm text-sand/70">
                    123 Ocean Avenue<br />
                    Daytona Beach, FL 32118
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <Phone className="h-4 w-4 flex-shrink-0 text-coral" />
                  <span className="font-courier text-sm text-sand/70">
                    (320) 468-6277
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <Mail className="h-4 w-4 flex-shrink-0 text-coral" />
                  <span className="font-courier text-sm text-sand/70">
                    stay@seasthebay.org
                  </span>
                </div>
              </div>
            </div>

            {/* Legal */}
            <div>
              <h4 className="font-anton text-lg tracking-wider uppercase">
                LEGAL STUFF
              </h4>
              <Separator className="my-3 bg-sand/20" />
              <div className="flex flex-col gap-2">
                <Link
                  to="/privacy"
                  data-testid="footer-link-privacy"
                  className="font-outfit text-sm text-sand/70 transition-colors hover:text-teal"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms"
                  data-testid="footer-link-terms"
                  className="font-outfit text-sm text-sand/70 transition-colors hover:text-teal"
                >
                  Terms of Service
                </Link>
                <a
                  href="https://hostbase.app/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-hostbase-privacy"
                  className="font-outfit text-sm text-sand/70 transition-colors hover:text-teal"
                >
                  HostBase Privacy
                </a>
                <a
                  href="https://hostbase.app/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-hostbase-terms"
                  className="font-outfit text-sm text-sand/70 transition-colors hover:text-teal"
                >
                  HostBase Terms
                </a>
              </div>
            </div>
          </div>

          <Separator className="my-10 bg-sand/20" />

          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="font-courier text-xs text-sand/50">
              &copy; {new Date().getFullYear()} Seas The Bay &middot; seasthebay.org &middot; All rights reserved.
            </p>
            <p className="font-marker text-xs text-sand/40">
              Innovation is not a crime.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
